<template>
    <div>
        <div class="page_header">
            <span class="page_title">{{ $t('overLevelStation.pageTitle') }}</span>
            <el-form class="vehicleclass" :inline="true" :size="size" style="flex:1;text-align: right;">
                <el-form-item :label="$t('overLevelStation.driverName')">
                    <el-input v-model="searchForm.driverName"
                        :placeholder="$t('overLevelStation.pleaseInputDriverName')" size="small"
                        style="width: 120px;"></el-input>
                </el-form-item>
                <el-form-item :label="$t('overLevelStation.stationName')">
                    <el-select v-model="searchForm.stationId" :placeholder="$t('overLevelStation.pleaseSelectStation')"
                        style="width: 140px;" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="station in stationList" :key="station.WayPointID"
                            :label="station.WayPointName" :value="station.WayPointID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('vehicleInfo.selectusedate')">
                    <el-date-picker v-model="searchForm.timeRange" type="daterange"
                        :range-separator="$t('commandHistory.to')" :start-placeholder="$t('commandHistory.startDate')"
                        :end-placeholder="$t('commandHistory.endDate')" value-format="yyyy-MM-dd"
                        style="width: 260px;"></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="searchClick" :loading="searching">
                        {{ $t('public.query') }}
                    </el-button>
                    <el-button @click="reset">
                        {{ $t('public.reset') }}
                    </el-button>
                    <el-button type="primary" plain @click="exportData" :loading="exporting">
                        <i class="el-icon-download"></i> {{ $t('public.export') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="page_container">

            <div style="flex: 1; overflow: auto;">
                <el-table :data="tableData" style="width: 100%;" border :loading="loading" height="calc(100vh - 280px)">
                    <el-table-column type="index" :label="$t('public.index')" width="60" align="center">
                    </el-table-column>
                    <el-table-column prop="vehicleNo" :label="$t('overLevelStation.vehicleNo')" min-width="120">
                    </el-table-column>
                    <el-table-column prop="driverName" :label="$t('overLevelStation.driverName')" min-width="100">
                    </el-table-column>
                    <el-table-column prop="stationName" :label="$t('overLevelStation.stationName')" min-width="120">
                    </el-table-column>
                    <el-table-column prop="inTime" :label="$t('overLevelStation.inTime')" min-width="180">
                    </el-table-column>
                    <el-table-column prop="calcStartTime" :label="$t('overLevelStation.calcStartTime')" min-width="180">
                    </el-table-column>
                    <el-table-column prop="outTime" :label="$t('overLevelStation.outTime')" min-width="180">
                    </el-table-column>
                    <el-table-column :label="$t('overLevelStation.totalStayDuration')" min-width="150" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.outTime">{{ scope.row.totalStayDuration }}</span>
                            <span v-else style="color: #909399;">--</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stayDuration" :label="$t('overLevelStation.stayDuration')" min-width="120">
                        <template slot-scope="scope">
                            <!--没有 outTime 不显示 stayDuration-->

                            <span v-if="scope.row.outTime">{{ scope.row.stayDuration }}</span>
                            <span v-else style="color: #909399;">--</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="maxAllowedTime" :label="$t('overLevelStation.maxAllowedTime')"
                        min-width="120">
                    </el-table-column>
                    <el-table-column prop="overTime" :label="$t('overLevelStation.overTime')" min-width="120">
                        <template slot-scope="scope">
                            <el-tag size="small" type="danger" v-if="scope.row.overTime > 0">{{ scope.row.overTime }} {{
                                $t('time.minute') }}</el-tag>
                            <span v-else class="normal-text">{{ $t('overLevelStation.normal') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <kl-pagination style="margin-bottom: 10px;" :total="total" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="currentPage">
            </kl-pagination>
        </div>
    </div>
</template>

<script>
import { queryVehicleOverstayRecords } from '@/http/api'
import { queryPointsInfo } from '@/http/vehicle'
import { mapState } from 'vuex'
export default {
    name: 'OverLevelStationManagement',
    data() {
        const today = this.getTodayStr();
        return {
            searchForm: {
                driverName: '',
                stationId: '',
                timeRange: [today, today]
            },
            tableData: [],
            stationList: [],
            loading: false,
            searching: false,
            exporting: false,
            currentPage: 1,
            pageSize: 10,
            total: 0
        };
    },
    computed: {
        size() {
            return this.$store.getters.size
        },
        operator() {
            return this.$store.getters.operator
        },
        ...mapState({

            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),
        selectedVehicleIds() {
            const vehicleIds = this.selectedVehicles
                .filter(item => item.treeLevel === 5)
                .map(item => item.nodeValue);
            return vehicleIds.join(',') || '';
        },
    },
    mounted() {
        this.loadStations();
        this.search();
    },
    methods: {
        getTodayStr() {
            const d = new Date();
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },

        // 加载站点（途经点）下拉列表，供筛选使用
        loadStations() {
            queryPointsInfo({ PageNo: 1, PageSize: 1000, PointName: '' }).then(res => {
                if (res.code === 200) {
                    this.stationList = res.data || [];
                }
            }).catch(() => { });
        },

        // 组装接口请求参数
        buildParams(pageNo, pageSize) {
            const params = {
                BeginTime: '',
                EndTime: '',
                pageNo: pageNo,
                pageSize: pageSize,
                VehicleIDS: this.selectedVehicleIds,
                DriverName: this.searchForm.driverName || '',
                WayPointID: this.searchForm.stationId || ''
            };
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.BeginTime = this.searchForm.timeRange[0] + ' 00:00:00';
                params.EndTime = this.searchForm.timeRange[1] + ' 23:59:59';
            }
            return params;
        },

        // 将接口返回数据映射为表格字段
        // 接口字段：VehicleID, CarNo, DriverName, WayPointName, MaxLeaveTime, EntryTime, DepartureTime, CalcStartTime
        formatRecords(data) {
            return (data || []).map(item => {
                const entry = this.parseTime(item.CalcStartTime);
                const depart = this.parseTime(item.DepartureTime);
                const inTimeObj = this.parseTime(item.EntryTime);
                let stayMinutes = 0;
                if (entry && depart) {
                    stayMinutes = (depart - entry) / 60000;
                }
                let totalStayMinutes = 0;
                if (inTimeObj && depart) {
                    totalStayMinutes = (depart - inTimeObj) / 60000;
                }
                const maxLeave = Number(item.MaxLeaveTime) || 0;
                const overTime = Math.max(0, Math.round(stayMinutes - maxLeave));
                return {
                    VehicleID: item.VehicleID,
                    vehicleNo: item.CarNo,
                    driverName: item.DriverName,
                    stationName: item.WayPointName,
                    inTime: item.EntryTime,
                    calcStartTime: item.CalcStartTime,
                    outTime: item.DepartureTime,
                    totalStayDuration: this.formatDuration(totalStayMinutes),
                    maxAllowedTime: maxLeave + ' ' + this.$t('time.minute'),
                    stayDuration: this.formatDuration(stayMinutes),
                    overTime: overTime
                };
            });
        },

        parseTime(str) {
            if (!str) return null;
            const [d, t] = str.split(' ');
            if (!d || !t) return null;
            const [y, m, day] = d.split('-').map(Number);
            const [hh, mm, ss] = t.split(':').map(Number);
            if ([y, m, day, hh, mm, ss].some(isNaN)) return null;
            return new Date(y, m - 1, day, hh, mm, ss);
        },

        formatDuration(minutes) {
            const total = Math.max(0, Math.round(minutes));
            const hours = Math.floor(total / 60);
            const mins = total % 60;
            if (hours > 0) {
                return hours + ' ' + this.$t('time.hour') + ' ' + mins + ' ' + this.$t('time.minute');
            }
            return mins + ' ' + this.$t('time.minute');
        },
searchClick() {
    this.currentPage = 1;
    this.search();

},
        search() {
            this.searching = true;
            this.loading = true;
            const params = this.buildParams(this.currentPage, this.pageSize);
            queryVehicleOverstayRecords(params).then(res => {
                this.searching = false;
                this.loading = false;
                if (res.code === 200) {
                    this.tableData = this.formatRecords(res.data);
                    this.total = res.recordsTotal || 0;
                } else {
                    this.$message.error(res.message || this.$t('overLevelStation.queryFailed'));
                    this.tableData = [];
                    this.total = 0;
                }
            }).catch(() => {
                this.searching = false;
                this.loading = false;
            });
        },

        reset() {
            const today = this.getTodayStr();
            this.searchForm = {
                driverName: '',
                stationId: '',
                timeRange: [today, today]
            };
            this.currentPage = 1;
            this.search();
        },

        exportData() {
            this.exporting = true;
            // 导出当前筛选条件下的全部数据
            const exportSize = this.total > 0 ? this.total : this.pageSize;
            const params = this.buildParams(1, exportSize);
            queryVehicleOverstayRecords(params).then(res => {
                this.exporting = false;
                if (res.code !== 200) {
                    this.$message.error(res.message || this.$t('overLevelStation.queryFailed'));
                    return;
                }
                const records = this.formatRecords(res.data);
                const headers = [
                    this.$t('public.index'),
                    this.$t('overLevelStation.vehicleNo'),
                    this.$t('overLevelStation.driverName'),
                    this.$t('overLevelStation.stationName'),
                    this.$t('overLevelStation.inTime'),
                    this.$t('overLevelStation.calcStartTime'),
                    this.$t('overLevelStation.outTime'),
                    this.$t('overLevelStation.totalStayDuration'),
                    this.$t('overLevelStation.stayDuration'),
                    this.$t('overLevelStation.maxAllowedTime'),
                    this.$t('overLevelStation.overTime')
                ];

                let csv = headers.join(',') + '\n';
                records.forEach((record, index) => {
                    const row = [
                        index + 1,
                        '"' + (record.vehicleNo || '') + '"',
                        '"' + (record.driverName || '') + '"',
                        '"' + (record.stationName || '') + '"',
                        '"' + (record.inTime || '') + '"',
                        '"' + (record.calcStartTime || '') + '"',
                        '"' + (record.outTime || '') + '"',
                        '"' + (record.totalStayDuration || '') + '"',
                        '"' + (record.stayDuration || '') + '"',
                        '"' + (record.maxAllowedTime || '') + '"',
                        record.overTime > 0 ? record.overTime + ' ' + this.$t('time.minute') : this.$t('overLevelStation.normal')
                    ];
                    csv += row.join(',') + '\n';
                });

                const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', this.$t('overLevelStation.pageTitle') + '_' + this.getTodayStr() + '.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                this.$message.success(this.$t('overLevelStation.exportSuccess'));
            }).catch(() => {
                this.exporting = false;
            });
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.search();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        }
    }
};
</script>

<style scoped>
.over-level-station-management {
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.page-header {
    margin-bottom: 20px;
    flex-shrink: 0;
}

.search-card {
    margin-bottom: 16px;
    flex-shrink: 0;
}

.search-form {
    padding: 10px 0;
}

.search-form-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.action-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
    flex-shrink: 0;
}

.data-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    min-height: 0;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    padding: 16px 0;
    border-top: 1px solid #ebeef5;
    flex-shrink: 0;
}

.normal-text {
    color: #67c23a;
}
</style>
